<div class="stick-top">
  <mat-toolbar><mat-icon>call_split</mat-icon> Payment Carriers</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/pay/paymentCarriers/0">
      <mat-icon>add</mat-icon>
      Create a new Payment Carrier
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th>
        <div class="vbox">
          Name
          <input [(ngModel)]="filter.name">
        </div>
      </th>
      <th>
        <div class="vbox">
          Url
          <input [(ngModel)]="filter.url">
        </div>
      </th>
      <th>
        <div class="vbox">
          Enabled
          <select  [(ngModel)]="filter.enabled">
            <option value="">ALL</option>
            <option value="true">ENABLED</option>
            <option value="false">DISABLED</option>
          </select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Type
          <micro-paymentCarrierType-select [(paymentCarrierTypeId)]="filter.paymentCarrierType"></micro-paymentCarrierType-select>
        </div>
      </th>
      <th>
        Service Fee %
      </th>
      <th>
        Min Service Fee
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td><a routerLink="/pay/paymentCarriers/{{element.id}}">{{element.name}}</a></td>
      <td>{{element.url}}</td>
      <td>{{element.enabled}}</td>
      <td>{{element.paymentCarrierType}}</td>
      <td>{{element.serviceFeePercentage}}%</td>
      <td>{{element.serviceFeeMinAmount | currency: undefined: undefined: '1.4-4'}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0">
      <td colspan="100"><em>No results found</em></td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="100">
        <mat-paginator #paginator
                       (page)="reload()"
                       [pageSize]="10"
                       [pageSizeOptions]="[5, 10, 20]">
        </mat-paginator>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
